import styled, { css } from 'styled-components';
import { Typography } from '../../ui/Typography';
import { FlexibleDiv } from '../../../styled/common';
import { Breakpoints } from '../../../styled/constants';
import { SectionHeaderContainer } from '../../NewSectionHeader/styled';
import { ToggleContainer, ToggleOption } from '../../ui/Toggle/styled';

export const AdsTitle = styled(Typography)`
  margin: 0;
  display: flex;
  gap: 5px;
`;

export const AdsTitleCount = styled(Typography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const SectionRightBlock = styled(FlexibleDiv)`
  justify-content: space-between;
  gap: 5px;
  width: 100%;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    gap: 10px;
  }
`;

export const MobilePriceViewToggleRow = styled.div`
  padding: 0 15px 20px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 0 40px 20px;
  }

  ${ToggleContainer} {
    max-width: 100%;
  }

  ${ToggleOption} {
    flex: 1 1 50%;
  }
`;

export const sectionStylesMapView = (
  isMapView: boolean,
  hasToggle: boolean
) => css`
  ${isMapView &&
  css`
    ${SectionHeaderContainer} {
      margin-bottom: 0;

      @media (min-width: ${Breakpoints.smallDesktop}px) {
        margin-bottom: 5px;
      }
    }
  `}

  ${hasToggle &&
  css`
    ${SectionHeaderContainer} {
      @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
        margin-bottom: 0;
        padding-bottom: 10px;
      }
    }
  `}
`;
